import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
export class FeatureGoldFishProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return !this.forceResponsive
            && super.equals(other)
            && this.pickedPrize.equals(other.pickedPrize)
            && this.missedPrize.equals(other.missedPrize)
            && this.titleText.equals(other.titleText)
            && this.helpText.equals(other.helpText)
            && this.spinCountPanel.equals(other.spinCountPanel)
            && this.winCountPanel.equals(other.winCountPanel)
            && this.spinCountValue.equals(other.spinCountValue)
            && this.winCountValue.equals(other.winCountValue)
            && this.spinCountLabel.equals(other.spinCountLabel)
            && this.winCountLabel.equals(other.winCountLabel)
            && this.spinWinValue.equals(other.spinWinValue)
            && this.reelsProperties.equals(other.reelsProperties)
            && this.respinTitle.equals(other.respinTitle)
            && this.respinMultiplierBackground.equals(other.respinMultiplierBackground)
            && this.respinMultiplierValue.equals(other.respinMultiplierValue)
            && this.logoProperties.equals(other.logoProperties);
    }
}
//# sourceMappingURL=FeatureGoldFishProperties.js.map